import React, { useState } from "react";
import {
  Container,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import LeftSideContent from "./LeftSideContent";
import RightSideContent from "./RightSideContent";
import Section from "./Section";
import { useEffect } from "react";
import { getToken } from "firebase/messaging";
import { messaging } from "./firebase-config";
import { onMessage } from "firebase/messaging";
import axios from "axios";
import { useParams } from "react-router-dom";
import classnames from "classnames";
import Sustainability from "./Sustainability";
import Environment from "./Environment";
import SafetyPersonnel from "./Safety_Personnel";
import SafetyCraft from "./Safety_Craft";
import ILO from "./ILO";

const Cof = () => {
  document.title = "Certificate of Fitness | StarMarket";

  // State for active tab
  const [activeTab, setActiveTab] = useState("1");

  // Toggle tab function
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    // Request permission to send notifications
  }, []);

  const { requestId, vesselNumber } = useParams();
  const username = "admin";
  const password = "password123";
  const sendNotificationOutside = async (vesselNumber) => {
    const vessel = vesselNumber;
    const requestNotificationPermission = async () => {
      try {
        const response = await axios.get(
          `https://api.starmarketapi.online/caf/cofRequest3/${requestId}`,
          {
            auth: {
              username,
              password,
            },
          }
        );

        console.log("Response from server:", response.data);
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          console.log("Notification permission granted.");
          // Get FCM token (device ID)
          const token = await getToken(messaging, {
            vapidKey:
              "BBWp8NC-KxklYuyVfI8qI0CDfjEnFgHcsTK0QUD7qYjwMI5Q1hFFS5B5WFP1N1dvv9A-APZRhQog05Nrlo_tRhM",
          });
          if (token) {
            console.log("FCM Token:", token);
            // Send the token to the server to register the device
            registerDevice(token);
            await sendNotification("COF", "COF Approved for " + vessel, [
              response.data.boatOwner,
              response.data.officer,
            ]);
          } else {
            console.error("No FCM token found.");
          }
        } else {
          console.log("Notification permission denied.");
        }
      } catch (error) {
        console.error("Error getting notification permission or token:", error);
      }
    };

    // Send device ID (FCM token) to your server
    const registerDevice = async (deviceId) => {
      try {
        const response = await fetch(
          "https://api.starmarketapi.online/login_firebase/register-device",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ deviceId }),
          }
        );
        const data = await response.json();
        console.log("Device registered:", data);
      } catch (error) {
        console.error("Error registering device:", error);
      }
    };

    requestNotificationPermission();

    // Listen for incoming messages (push notifications)
    const listenForMessages = () => {
      onMessage(messaging, (payload) => {
        console.log("Message received:", payload);
        // You can show a browser notification or update your UI
        if (Notification.permission === "granted") {
          new Notification(payload.notification.title, {
            body: payload.notification.body,
          });
        }
      });
    };

    listenForMessages();

    const sendNotification = async (title, body, receivers) => {
      try {
        const notificationData = {
          title: title,
          body: body,
          receivers: receivers,
        };
        // Send POST request to the server with notification data
        const response = await axios.post(
          "https://api.starmarketapi.online/notifications/send-notification",
          notificationData
        );

        // Handle the response from the server
        console.log("Response from server:", response.data);
      } catch (error) {
        // Handle errors
        console.error("Error sending notification:", error);
      }
    };
  };

  return (
    <React.Fragment>
      <section className="section gaps bg-light" style={{ paddingTop: "80px" }}>
        <Container fluid>
          <Section link="Profile" />
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggleTab("1")}
              >
                COF
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggleTab("2")}
              >
                Sustaianbility
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => toggleTab("3")}
              >
                Environment
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "4" })}
                onClick={() => toggleTab("4")}
              >
                Safety - Personnel
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "5" })}
                onClick={() => toggleTab("5")}
              >
                Safety - Craft
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "6" })}
                onClick={() => toggleTab("6")}
              >
                ILO C188
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row>
                <LeftSideContent />
                <RightSideContent
                  sendFunction={sendNotificationOutside}
                  requestId={requestId}
                  vesselNumber={vesselNumber}
                />
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                <div className="p-4">
                  <Sustainability
                    requestId={requestId}
                    vesselNumber={vesselNumber}
                  />
                </div>
              </Row>
            </TabPane>
            <TabPane tabId="3">
              <Row>
                <div className="p-4">
                  <Environment
                    requestId={requestId}
                    vesselNumber={vesselNumber}
                  />
                </div>
              </Row>
            </TabPane>
            <TabPane tabId="4">
              <Row>
                <div className="p-4">
                  <SafetyPersonnel
                    requestId={requestId}
                    vesselNumber={vesselNumber}
                  />
                </div>
              </Row>
            </TabPane>
            <TabPane tabId="5">
              <Row>
                <div className="p-4">
                  <SafetyCraft
                    requestId={requestId}
                    vesselNumber={vesselNumber}
                  />
                </div>
              </Row>
            </TabPane>
            <TabPane tabId="6">
              <Row>
                <div className="p-4">
                  <ILO requestId={requestId} vesselNumber={vesselNumber} />
                </div>
              </Row>
            </TabPane>
          </TabContent>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Cof;
